// extracted by css-extract-rspack-plugin
export default {"auctionInput":"auction-input--njrjBof1AplvtOCU"};